import { Component } from '@angular/core';

@Component({
  selector: 'app-feature-section-redesign',
  templateUrl: './feature-section-redesign.component.html',
  styleUrls: ['./feature-section-redesign.component.scss']
})
export class FeatureSectionRedesignComponent {

}
